import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const heroStats = [
  { value: "120万+", label: "注册漫友" },
  { value: "3.2万", label: "活跃漫圈" },
  { value: "680万", label: "讨论帖" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/works?q=${encodeURIComponent(q)}` : "/works");
  };

  return (
    <section className="relative min-h-[640px] md:min-h-[720px] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20lively%20community%20of%20diverse%20young%20characters%20chatting%20and%20laughing%20over%20open%20comic%20books%20in%20a%20cozy%20warm%20lounge%2C%20coral%20orange%20teal%20and%20cream%20color%20palette%2C%20soft%20warm%20lighting%2C%20dynamic%20manga%20storyboard%20energy%2C%20high%20detail%20illustration&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="178漫画网漫友同好交流聚集地"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65" />
      </div>

      <div className="relative z-10 w-full max-w-4xl px-4 md:px-6 pt-28 md:pt-36 pb-16 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 text-background-50 backdrop-blur px-4 py-1.5 text-xs md:text-sm font-medium border border-background-50/20">
          <i className="ri-vip-crown-2-line" />
          178漫画网同好交流聚集地 · 按作品和题材划分漫圈
        </span>

        <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-tight text-background-50">
          追漫，
          <span className="text-secondary-300">从此有人陪聊</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm md:text-lg leading-7 text-background-100">
          每部漫画下方都有讨论区，热门作品更有专属圈子。随时找到同好交流剧情、分享心得，在178漫画网混个脸熟，追漫再也不孤单。
        </p>

        <form
          onSubmit={onSubmit}
          className="mx-auto mt-8 flex max-w-xl flex-col sm:flex-row gap-2 bg-background-50/15 backdrop-blur p-1.5 rounded-full border border-background-50/25"
        >
          <div className="flex flex-1 items-center gap-2 px-4">
            <i className="ri-search-line text-background-100" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索作品、漫圈或讨论，如：星轨漂流记"
              className="w-full bg-transparent py-2.5 text-sm text-background-50 placeholder:text-background-200 outline-none"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-400 transition-colors"
          >
            搜漫圈
          </button>
        </form>

        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/works"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-400 px-6 py-3 text-sm font-medium text-foreground-950 hover:bg-secondary-300 transition-colors"
          >
            <i className="ri-arrow-right-circle-line text-lg" />
            逛热门作品
          </Link>
          <Link
            to="/circles"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 hover:bg-background-50/10 transition-colors"
          >
            <i className="ri-user-heart-line text-lg" />
            加入漫圈
          </Link>
        </div>

        <dl className="mx-auto mt-12 grid max-w-lg grid-cols-3 gap-4">
          {heroStats.map((s) => (
            <div key={s.label} className="rounded-2xl bg-background-50/10 backdrop-blur px-3 py-4 border border-background-50/15">
              <dt className="order-2 mt-1 text-xs text-background-200">{s.label}</dt>
              <dd className="font-heading text-2xl md:text-3xl text-secondary-300">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}